import React, { createContext } from "react";
import "./ScannerTableRow.css";
import { Form } from "antd";

export const FormContext = createContext(null);

function ScannerTableRow({
  record, index, checkRowDisabled, ...antdProps
}) {
  if (!record) { // recheck message row
    return <tr {...antdProps} />; // eslint-disable-line react/jsx-props-no-spreading
  }

  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <FormContext.Provider value={form}>
        <tr
          {...antdProps} // eslint-disable-line react/jsx-props-no-spreading
          className={`${antdProps.className} ScannerTable__Row${checkRowDisabled(record) ? "--disabled" : ""}${record.recheck ? "--recheck" : ""}`}
        />
      </FormContext.Provider>
    </Form>

  );
}

export default ScannerTableRow;
